exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root-faq-page[data-v-1f8dd7ba]{display:flex;justify-content:center;overflow:hidden}.root-faq-page .about-page[data-v-1f8dd7ba]{min-height:100vh;width:100%}", ""]);

// exports
